import { render, staticRenderFns } from "./ViewTypeSwitcher.vue?vue&type=template&id=5f9a49a7"
import script from "./ViewTypeSwitcher.vue?vue&type=script&lang=js"
export * from "./ViewTypeSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports